
import { defineComponent, PropType } from 'vue'
import PaperHeroStats from './PaperHeroStats.vue'
import ExternalLinks from './ExternalLinks.vue'
import FavoritePaperButton from './FavoritePaperButton.vue'
import Authors from './Authors.vue'
import { Paper } from '@/types/incitefulTypes'
import { ExclamationIcon } from '@heroicons/vue/outline'
import { EmitEvents } from '@/utils/emitHelpers'

export default defineComponent({
  name: 'PaperHero',
  props: {
    paper: {} as PropType<Paper>,
    graphStats: { type: Boolean, default: false }
  },
  components: {
    PaperHeroStats,
    Authors,
    ExternalLinks,
    ExclamationIcon,
    FavoritePaperButton
  },
  data() {
    return {
      receivedLoaded: false
    }
  },
  watch: {
    paper() {
      this.receivedLoaded = false
    }
  },
  mounted() {
    this.emitter.on(EmitEvents.GraphLoaded, () => {
      this.receivedLoaded = true
    })
  }
})
